import { message } from "antd";
import axios from "./axios";

const DiscountService = {
   
    getDiscountDetails: async (id) => {
        try {
            const response = await axios.get(`discount_codes`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDiscountsCode: async (id) => {
        try {
            const response = await axios.get(`/discounts/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDiscounts: async (id,page=1) => {
        try {
            const response = await axios.get(`discounts?page=${page}&count=10`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    deleteDiscounts: async (id) => {
        try {
            const response = await axios.delete(`/discounts/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    deleteDiscountCode: async (id) => {
        try {
            const response = await axios.delete(`/discount_codes/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    addDiscountsCode: async (payload) => {
        try {
            const response = await axios.post('/discount_codes',payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    updateDiscountsCode: async (payload, id) => {
        try {
            const response = await axios.put(`/discount_codes/${id}`,payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDiscountByID: async (id) => {
        try {
            const response = await axios.get(`/discounts/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    addDiscounts: async (payload) => {
        try {
            const response = await axios.post('/discounts',payload);
            return response.data;
        } catch(error) {
      const errorResponse = error.response;
      const errorData = errorResponse ? errorResponse.data : null;
// message.error(errorData?.msg)
    
      return errorData
        }
    },
    updateDiscounts: async (payload,id) => {
        try {
            const response = await axios.put(`/discounts/${id}`,payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    generateCode: async () => {
        try {
            const response = await axios.get(`/generate/discount_code`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    }
 
};

export default DiscountService;